import { IStopAddress } from '@okcargo-apps/shared-domain';
import { IAddressBookEntry } from '@okcargo-apps/shared-domain-ionic';
import { AddressResponse } from '@okcargo/query-processor';

export function mapFromAddressBookResponse(dto: AddressResponse): IAddressBookEntry {
  const entryDisplayText =
    dto.postalCode && dto.city && dto.stateCode
      ? `${dto.street}, ${dto.postalCode} ${dto.city} (${dto.stateCode})`
      : (dto.street ?? '');

  return {
    textToDisplay: entryDisplayText,
    company: dto.companyName,
    placeId: dto.predictionId,
    ...(dto.addressBookId
      ? {
          address: {
            addressbookId: dto.addressBookId,
            company: dto.companyName ?? '',
            street: dto.street ?? '',
            extraLine: dto.extraLine ?? '',
            city: dto.city ?? '',
            postalCode: dto.postalCode ?? '',
            state: dto.stateCode ?? '',
            stateCode: dto.stateCode ?? '',
            country: dto.countryCode ?? '',
            countryCode: dto.countryCode ?? '',
            coords: dto.pointPayload
              ? { latitude: dto.pointPayload.latitude, longitude: dto.pointPayload.longitude }
              : null,
            phone: dto.companyPhone ?? '',
            //taxId: dto.companyTaxNumber ?? '',
          } as IStopAddress,
        }
      : {}),
  };
}

export function mapFromPlaceAddressResponse(dto: AddressResponse): IStopAddress {
  return {
    // addressbookId: dto.id,
    // company: dto.company?.name ?? '',
    street: dto.street ?? '',
    extraLine: dto.extraLine ?? '',
    city: dto.city ?? '',
    postalCode: dto.postalCode ?? '',
    // state: dto.stateCode ?? '',
    stateCode: dto.stateCode ?? '',
    // country: dto.countryCode ?? '',
    countryCode: dto.countryCode ?? '',
    coords: dto.pointPayload ? { latitude: dto.pointPayload.latitude, longitude: dto.pointPayload.longitude } : null,
    // phone: dto.company?.phone ?? '',
    // taxId: dto.company?.taxNumber ?? '',
  } as IStopAddress;
}
